import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';

export const notSelfGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const targetId = route.paramMap.get('id');

  return authService.initializeAuth().pipe(
    map(() => {
      const currentUser = authService.getCurrentUser();
      if (!targetId || !currentUser || targetId !== currentUser.id) {
        return true;
      }
      return router.createUrlTree(['/settings/users']);
    }),
  );
};
